// Angular
import { Injectable } from '@angular/core';
import { ISsr, IXId } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { ServiceCategory } from 'libraries/service/resources/booking/interfaces/get-bookings.enum';
import { IGetEnumsService } from 'libraries/service/booking/enums/IGetEnums';
import { Yii } from 'libraries/interfaces/Yii';

export interface IServiceByCategoryGettersInput{
    ssr: ISsr[];
    travellerXId: string;
    sectorXId: string;
    serviceEnum: IGetEnumsService[];
}
interface IServiceByCategoryGetterInput extends IServiceByCategoryGettersInput{
    category: ServiceCategory;
}

@Injectable()
export class SectorAirServicesService {

    public getLuggageServices(serviceData: IServiceByCategoryGettersInput): string{
        return this.getServiceByCategory({...serviceData, category: ServiceCategory.luggage});
    }

    public getMealplanServices(serviceData: IServiceByCategoryGettersInput): string{
        return this.getServiceByCategory({ ...serviceData, category: ServiceCategory.mealplan });
    }

    public getSeatServices(serviceData: IServiceByCategoryGettersInput): string{
        return this.getServiceByCategory({ ...serviceData, category: ServiceCategory.seat });
    }

    public getTicketServices(serviceData: IServiceByCategoryGettersInput): string{
        return this.getServiceByCategory({ ...serviceData, category: ServiceCategory.ticket });
    }

    public getFilteredServiceListFromEnum(serviceEnum: IGetEnumsService[], category: ServiceCategory): IGetEnumsService[] {
        return serviceEnum.filter((service: IGetEnumsService) => service.category.indexOf(category) > -1);
    }

    public getServiceCategoryLabel(serviceCategory: ServiceCategory): string {
        switch (serviceCategory) {
            case ServiceCategory.ancillary: return Yii.t('wui-shared-js', "Services annexes");
            case ServiceCategory.animal: return Yii.t('wui-shared-js', "Animaux");
            case ServiceCategory.luggage: return Yii.t('wui-shared-js', "Bagages");
            case ServiceCategory.mealplan: return Yii.t('wui-shared-js', "Repas");
            case ServiceCategory.payment: return Yii.t('wui-shared-js', "Paiements");
            case ServiceCategory.seat: return Yii.t('wui-shared-js', "Sièges");
            case ServiceCategory.ticket: return Yii.t('wui-shared-js', "Billets");
            case ServiceCategory.unknown: return Yii.t('wui-shared-js', "Catégorie inconnue");
            default: return null;
        }
    }

    private getServiceByCategory({ ssr, travellerXId, sectorXId, serviceEnum, category }: IServiceByCategoryGetterInput): string {
        const allowedServiceInSelectedCategory: IGetEnumsService[] = this.getFilteredServiceListFromEnum(serviceEnum, category);
        const services: string = ssr
            .filter((ssrItem: ISsr) =>
                allowedServiceInSelectedCategory.find((service: IGetEnumsService) => service.code === ssrItem.code) &&
                ssrItem.sector &&
                ssrItem.sector.find((sector: IXId) => sector.xId === sectorXId) &&
                ssrItem.traveller &&
                ssrItem.traveller.find((traveller: IXId) => traveller.xId === travellerXId)
            )
            .map((ssrItem: ISsr) => `${ssrItem.name} (${ssrItem.code})`)
            .join(', ');
        return services !== '' ? services : undefined;
    }

}

